// Description: Page to update the data of an existing template
// Updated: 07/08/2025

// React Components and DOM Elements
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Material UI Components
import {
  Box,
  Button,
  FormControl,
  Grid,
  TextField,
  useMediaQuery,
} from "@mui/material";

// Components and functions from the project
import { GetVariables } from "../../api/aws/Listagens/GetVariables";
import ViewWhatsAppScreen from "../../components/WhatsAppScreen/ViewWhatsAppScreen";
import { isAuthenticated } from "../../authMiddleware";
import FormWhatsApp from "./TemplateFormWhatsApp";
import FormSMS from "./TemplateFormSMS";
import HeaderPage from "../../components/HeaderPage/HeaderPage";
import ThemeColors from "../../components/ThemeColors/ThemeColors";
import Footer from "../../components/Footer/Footer";
import EmailFormShowCase from "../../components/EmailFormShowCase/EmailFormShowCase";
import Loading from "../../components/Loading/Loading";
import { TemplateUpdate } from "../../api/aws/Templates/UpdateTemplate";
import { GetAllTemplates } from "../../api/aws/Templates/GetAllTemplates";
import { notify, updateMessageType } from "../../utils/utils";
import ModalR from "../../components/Modals/ModalR";
import use123zapStore from "../../context/123zapStore";
import { TestMessage } from "../../api/aws/Templates/TestMessage";
import TestTemplateModal from "../../components/Modals/TestTemplateModal";

// Render The Page
function EditTemplate() {
  // Authentication Context Functions
  const templates = use123zapStore((state) => state.templates);
  const userAuthenticated = use123zapStore((state) => state.userAuthenticated);
  const userInfo = use123zapStore((state) => state.userInfo);
  const setUserInfo = use123zapStore((state) => state.setUserInfo);
  const alreadyFetchTemplates = use123zapStore((state) => state.alreadyFetchTemplates);
  const setAlreadyFetchTemplates = use123zapStore((state) => state.setAlreadyFetchTemplates);
  const Navigate = useNavigate();

  // Template Id State
  const [templateId, setTemplateId] = useState(
    localStorage.getItem("templateId") || null
  );

  // Form States default
  const [title, setTitle] = useState("");
  const [typeMessage, setTypeMessage] = useState("Atrasos");
  const [selected, setSelected] = useState("Atrasos");
  const buttons = [
    "Atrasos",
    "Avisos",
    "Faturas",
    "Inadimplências",
    "Marketing",
    "Outros",
  ];

  useEffect(() => {
    console.log("templateId", templateId);
  }, [templateId]);

  const isSmallScreen = useMediaQuery("(max-width:1200px)");
  const [showPreview, setShowPreview] = useState(false);

  // Email States
  const [emailTitle, setEmailTitle] = useState("");
  const [initialGreeting, setInitialGreeting] = useState("");
  const [messageTemporaryEmail, setMessageTemporaryEmail] = useState("");
  const [referenceDesign, setReferenceDesign] = useState("");
  const [background, setBackground] = useState();
  const [isEmailTemplatePersonalized, setIsEmailTemplatePersonalized] = useState("");
  const [templateType, setTemplateType] = useState("");
  const [templateStatus, setTemplateStatus] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openTestModal, setOpenTestModal] = useState(false);
  const [wppNumber, setWppNumber] = useState("");

  // WhatsApp States
  const [messageTemporaryWhatsApp, setMessageTemporaryWhatsApp] = useState("");
  const [integration_system, setIntegrationSystem] = useState("codeChat");

  // Template States
  const [variablesOfTemplate, setVariablesOfTemplate] = useState({});
  const [palletOfColors, setPalletOfColors] = useState("N/A");

  // Message States
  const [messageTemporary, setMessageTemporary] = useState("");
  const [typeChannel, setTypeChannel] = useState();

  // Loading Transition state
  const [showLoading, setShowLoading] = useState(true);

  // Component Props State
  const [viewWhatsAppScreenProps, setViewWhatsAppScreenProps] = useState({
    messages: {
      messages: [],
    },
  });

  // Effect to Check Authentication and Fetch User Info
  useEffect(() => {
    if (userAuthenticated && Object.keys(userInfo).length === 0) {
      const { decryptedData } = isAuthenticated();
      setUserInfo(decryptedData);
    }
  }, []);

  // Effect to Fetch Data from API
  useEffect(() => {
    if (userInfo["UUID"]) {
      fetchData();

      if (templateId === null) {
        Navigate("/modelos");
        return;
      }

      fetchTemplatesData();
    }
  }, [userInfo]);

  // Pega as variáveis do template
  const fetchData = async () => {
    try {
      const translations = {
        Personal_information: "Informações Pessoais",
        Contact: "Contato",
        Address: "Endereço",
        Financial_References: "Referências Financeiras",
      };

      const resultJson = await GetVariables();
      const result = resultJson.data.reduce((acc, item) => {
        const category = translations[item.category] || item.category; // Traduz a categoria, ou usa o nome original caso não haja tradução
        if (!acc[category]) {
          acc[category] = [];
        }

        // limita a 10 itens

        acc[category].push(item.variableName);

        return acc;
      }, {});

      //console.log(result, "Template Variables");

      setVariablesOfTemplate(result);
    } catch (error) {
      console.error("Error fetching data from API:", error);
    }
  };

  // UseEffect
  useEffect(() => {
    if (typeChannel === 'SMS') {
      setViewWhatsAppScreenProps((prevProps) => ({
        ...prevProps,
        messages: {
          messages: [{ id: prevProps.messages.messages.length + 1, type: 'sms', message: messageTemporary, fromMe: true }],
        },
      }));
    } else if (typeChannel === 'E-mail') {

      setViewWhatsAppScreenProps((prevProps) => ({
        ...prevProps,
        messages: {
          messages: [{ id: prevProps.messages.messages.length + 1, type: 'email', message: messageTemporary, fromMe: true, titleEmail: emailTitle, initialGreeting: initialGreeting }
          ],
        },
      }));

    }

  }, [messageTemporary, emailTitle, initialGreeting]);

  // Function to get the template data
  const fetchTemplatesData = async () => {
    try {
      const resultJson = await GetAllTemplates();

      const items = resultJson.data
        .map((template) => {
          return {
            id: template.id,
            title: template.title,
            channel_type: template.channel_type,
            status: template.status,
            msg_type: template.msg_type,
            type: template.type,
            background: template.background,
            messageJson: template.channel_type === "WhatsApp" || template.channel_type === "WhatsAppWEB" || template.channel_type === "SMS" ? updateMessageType(template.message_json) : template.message_json,
          };
        })
        .filter((item) => item !== null);

      console.log(items, 'items')

      const findTemplate = items.find((item) => item.id === templateId);

      setTypeChannel(findTemplate.channel_type);
      setSelected(findTemplate.msg_type);
      setTemplateStatus(findTemplate.status);
      setTemplateType(findTemplate.type);

      if (findTemplate.channel_type === "WhatsApp" || findTemplate.channel_type === "WhatsAppWEB") {
        setTitle(findTemplate.title);

        setViewWhatsAppScreenProps((prevProps) => ({
          ...prevProps,
          messages: {
            messages: findTemplate.messageJson.messages,
          },
        }));
      } else if (findTemplate.channel_type === "SMS") {
        setTitle(findTemplate.title);

        const findMessage = findTemplate.messageJson.messages.find(
          (message) => message.type === "sms"
        );

        setMessageTemporary(findMessage.message);

        setViewWhatsAppScreenProps((prevProps) => ({
          ...prevProps,
          messages: {
            messages: findTemplate.messageJson.messages,
          },
        }));
      } else if (findTemplate.channel_type === "E-mail") {
        setTitle(findTemplate.title);

        const findMessage = findTemplate.messageJson.messages.find(
          (message) => message.type === "email"
        );

        setEmailTitle(findMessage.titleEmail);
        setInitialGreeting(findMessage.initialGreeting);

        setMessageTemporary(findMessage.message);

        setIsEmailTemplatePersonalized(
          findTemplate.type === "Custom" ? true : false
        );

        setBackground(findTemplate.background);
        setViewWhatsAppScreenProps((prevProps) => ({
          ...prevProps,
          messages: {
            messages: findTemplate.messageJson.messages,
          },
        }));
      }
    } catch (error) {
      console.error("Erro ao obter modelos:", error);
    } finally {
      setShowLoading(false);
    }
  };

  // Function to edit the template
  const updateTemplate = async () => {
    if (
      typeChannel === "E-mail" &&
      (emailTitle === "" ||
        initialGreeting === "" ||
        viewWhatsAppScreenProps.messages.messages.length === 0)
    ) {
      console.log(
        "typeChannel",
        typeChannel,
        "emailTitle",
        emailTitle,
        "initialGreeting",
        initialGreeting,
        "mensagens",
        viewWhatsAppScreenProps.messages.messages.length
      );

      return;
    }

    let info = {};

    const get_messages = viewWhatsAppScreenProps.messages.messages.map((message) => {
      return {
        type: (message.type === "whatsapp" || message.type === "sms") ? "text" : message.type === "img" ? "img" : message.type,
        content: message.message
      };
    });

    if (typeChannel === "E-mail") {
      info = {
        title: title,
        messages: viewWhatsAppScreenProps.messages,
        msg_type: typeMessage,
        channel_type: typeChannel,
        background: background,
        id_template: templateId
      };
    } else if (typeChannel === "WhatsAppWEB") {
      info = {
        title: title,
        messages: get_messages,
        msg_type: typeMessage,
        channel_type: "WhatsAppWEB",
        id_template: templateId
      };
    } else if (typeChannel === "SMS") {
      info = {
        title: title,
        messages: get_messages,
        msg_type: typeMessage,
        channel_type: typeChannel,
        id_template: templateId
      };
    }

    console.log(info);

    const resultJson = await TemplateUpdate(info);

    if (resultJson["status"] === "success") {
      notify("Success", "Modelo editado com sucesso!", true);
      setAlreadyFetchTemplates(false);
      Navigate("/modelos");
    }
  };

  const sendTestMessage = async () => {
    if (wppNumber === "") {
      notify("Alert", "Preencha todos os campos", true);
      return;
    }

    let info = {};

    const get_messages = viewWhatsAppScreenProps.messages.messages.map((message) => {
      return {
        type: (message.type === "whatsapp" || message.type === "sms") ? "text" : message.type === "img" ? "img" : message.type,
        content: message.message
      };
    });

    info = {
      title: title,
      messages: get_messages,
      msg_type: typeMessage,
      channel_type: typeChannel,
      number: String(`55${wppNumber}`).replace(/\D/g, "")
    };


    await TestMessage(info).then((response) => {
      if (response.status === "success") {
        notify("Success", "Mensagem enviada com sucesso!", true);
      } else {
        notify("Error", "Ocorreu algum erro, tente novamente mais tarde.", true);
      }

      setOpenTestModal(false);
    })
  };

  const handleClick = (value) => {
    setSelected(value);
    setTypeMessage(value);
  };

  const verifyFieldsBeforeSave = () => {
    if (title === "") {
      notify("Error", "Preencha o título do modelo", true);
    } else if ((typeChannel === "SMS" && messageTemporary.length === 0) || (typeChannel === "WhatsAppWEB" && viewWhatsAppScreenProps.messages.messages.length === 0)) {
      notify("Error", "Escreva uma mensagem antes de salvar o modelo", true);
    } else if (title === "" && messageTemporary.length === 0) {
      notify("Error", "Preencha todos os campos", true);
    } else {
      setOpenModal(true);
    }
  }

  // Show the loading screen
  if (showLoading) {
    return <Loading open={true} />;
  }

  return (
    <>
      <HeaderPage />
      <Box sx={{ background: "#F7F7FC" }}>
        <Grid container spacing={2} style={{ paddingTop: "20px" }}>
          <Grid
            item
            xs={12}
            lg={6}
            xl={6}
            sx={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <Box
              sx={{
                flexGrow: 1,
                justifyContent: "center",
                backgroundColor: "#F7F7FC",
                width: { xs: "561.200px", lg: "90%" },
                margin: { xs: "0 auto 20px", lg: "0 auto" },
                padding: { xs: 0, lg: "20px 0px 20px 30px", xl: "20px" },
              }}
            >
              <FormControl fullWidth>
                <TextField
                  id="outlined-basic"
                  label="Nome do seu Modelo"
                  variant="standard"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  InputLabelProps={{
                    style: { fontSize: "20px" }, // Ajuste o tamanho da fonte conforme necessário
                  }}
                />
              </FormControl>
              <Box
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                {buttons.map((button, index) => (
                  <Button
                    key={button}
                    onClick={() => handleClick(button)}
                    sx={{
                      flexGrow: 1,
                      mx: index === 0 || index === buttons.length - 1 ? 0 : 0.5,
                      bgcolor:
                        selected === button ? "#8142FC" : ThemeColors.gray30,
                      color: "#fff",
                      borderRadius: "27px",
                      "&:hover": {
                        bgcolor: selected === button ? "#8142FC" : "gray",
                      },
                      fontSize: { xs: '11px', xl: '12px' },
                      padding: { xs: '3px 12px', xl: '4px 16px' }
                    }}
                  >
                    {button}
                  </Button>
                ))}
              </Box>

              <Box
                position={"relative"}
                marginBottom={isSmallScreen && showPreview ? "20px" : "none"}
              >
                <Box
                  sx={{
                    color: "rgb(129, 66, 252)",
                    fontSize: "18px",
                    position: "absolute",
                    top:
                      typeChannel === "WhatsAppWEB" || typeChannel === "WhatsApp" || typeChannel === "SMS"
                        ? "16px"
                        : typeChannel === "E-mail" && showPreview
                          ? "16px"
                          : "0px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: isSmallScreen ? "block" : "none",
                    fontFamily: "Satoshi",
                    cursor: "pointer",
                    zIndex: "10",
                  }}
                  onClick={() => setShowPreview((prev) => !prev)}
                >
                  {!showPreview ? "Exibir Prévia" : "Esconder Prévia"}
                </Box>
                <Box
                  sx={{
                    display: isSmallScreen && showPreview ? "none" : "block",
                  }}
                >
                  {typeChannel === "WhatsAppWEB" || typeChannel === "WhatsApp" ? (
                    <FormWhatsApp
                      messageTemporaryWhatsApp={messageTemporaryWhatsApp}
                      setMessageTemporary={setMessageTemporaryWhatsApp}
                      palletOfColors={palletOfColors}
                      setPalletOfColors={setPalletOfColors}
                      variablesOfTemplate={variablesOfTemplate}
                      typeMessage={typeMessage}
                      setTypeMessage={setTypeMessage}
                      setViewWhatsAppScreenProps={setViewWhatsAppScreenProps}
                      viewWhatsAppScreenProps={viewWhatsAppScreenProps}
                      integration_system={integration_system}
                      setIntegrationSystem={setIntegrationSystem}
                      saveTemplate={verifyFieldsBeforeSave}
                      setOpenTestModal={setOpenTestModal}
                      edit
                    />
                  ) : typeChannel === "SMS" ? (
                    <FormSMS
                      messageTemporary={messageTemporary}
                      setMessageTemporary={setMessageTemporary}
                      variablesOfTemplate={variablesOfTemplate}
                      setViewWhatsAppScreenProps={setViewWhatsAppScreenProps}
                      viewWhatsAppScreenProps={viewWhatsAppScreenProps}
                      saveTemplate={verifyFieldsBeforeSave}
                      openTestModal={openTestModal}
                      setOpenTestModal={setOpenTestModal}
                      edit
                    />
                  ) : null}
                </Box>
              </Box>

              <Box
                sx={{
                  display: { xs: "none", lg: "flex" },
                  justifyContent: "start",
                  alignItems: "end",
                  minHeight: "80px",
                }}
              >
                <Footer />
              </Box>
            </Box>
          </Grid>
          {isSmallScreen && showPreview === true ? (
            <Grid
              item
              xs={12}
              lg={6}
              xl={6}
              padding={{ xs: "0 0 20px 0", lg: "0", xl: "0" }}
            >
              {typeChannel === "WhatsAppWEB" || typeChannel === "WhatsApp" || typeChannel === "SMS" ? (
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#FFFF",
                    padding: "20px",
                    borderRadius: "15px",
                    minHeight: { sm: "696px", lg: "100%", xl: "100%" },
                    width: { sm: "561.200px", lg: "100%", xl: "100%" },
                    margin: { sm: "0 auto", lg: "0", xl: "0" },
                  }}
                >
                  <ViewWhatsAppScreen
                    {...viewWhatsAppScreenProps}
                    emailTitle={emailTitle}
                    setEmailTitle={setEmailTitle}
                    initialGreeting={initialGreeting}
                    setInitialGreeting={setInitialGreeting}
                    message={messageTemporaryEmail}
                    setMessageTemporary={setMessageTemporaryEmail}
                    open={true}
                    palletOfColors={palletOfColors}
                    setPalletOfColors={setPalletOfColors}
                    setViewWhatsAppScreenProps={setViewWhatsAppScreenProps}
                    viewWhatsAppScreenProps={viewWhatsAppScreenProps}
                    type={typeChannel === "WhatsAppWEB" ? "whatsapp" : "sms"}
                  />
                </Box>
              ) : (
                <EmailFormShowCase
                  isEmailTemplatePersonalized={isEmailTemplatePersonalized}
                  greeting={initialGreeting}
                  titleModel={title}
                  title={emailTitle}
                  message={messageTemporary}
                  background={background}
                  setBackground={setBackground}
                />
              )}
            </Grid>
          ) : !isSmallScreen ? (
            <Grid
              item
              xs={12}
              lg={6}
              xl={6}
              padding={{ xs: "0 0 20px 0", lg: "0", xl: "0" }}
            >
              {typeChannel === "WhatsAppWEB" || typeChannel === "WhatsApp" || typeChannel === "SMS" ? (
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#FFFF",
                    padding: "20px",
                    borderRadius: "15px",
                    minHeight: { xs: "696px", lg: "100%", xl: "100%" },
                    width: { xs: "561.200px", lg: "100%", xl: "100%" },
                    margin: { xs: "0 auto", lg: "0", xl: "0" },
                  }}
                >
                  <ViewWhatsAppScreen
                    {...viewWhatsAppScreenProps}
                    emailTitle={emailTitle}
                    setEmailTitle={setEmailTitle}
                    initialGreeting={initialGreeting}
                    setInitialGreeting={setInitialGreeting}
                    message={messageTemporaryEmail}
                    setMessageTemporary={setMessageTemporaryEmail}
                    open={true}
                    palletOfColors={palletOfColors}
                    setPalletOfColors={setPalletOfColors}
                    setViewWhatsAppScreenProps={setViewWhatsAppScreenProps}
                    viewWhatsAppScreenProps={viewWhatsAppScreenProps}
                    type={typeChannel === "WhatsAppWEB" ? "whatsapp" : "sms"}
                  />
                </Box>
              ) : (
                <EmailFormShowCase
                  isEmailTemplatePersonalized={isEmailTemplatePersonalized}
                  greeting={initialGreeting}
                  titleModel={title}
                  title={emailTitle}
                  message={messageTemporary}
                  background={background}
                  setBackground={setBackground}
                />
              )}
            </Grid>
          ) : null}
          <Box
            sx={{
              padding: "20px 0 0 0",
              display: { xs: "block", lg: "none" },
              width: { xs: "561.200px", lg: "100%", xl: "100%" },
              margin: { xs: "0 auto", lg: "0", xl: "0" },
            }}
          >
            <Footer />
          </Box>
        </Grid>
      </Box>

      <TestTemplateModal channelType={typeChannel} isOpen={openTestModal} onClose={() => setOpenTestModal(false)} onConfirm={sendTestMessage} wppNumber={wppNumber} setWppNumber={setWppNumber} />
      <ModalR
        cancelText={"Mudei de ideia"}
        color={ThemeColors.purple500}
        confirmText={"Salvar alterações"}
        subTitle={"Deseja salvar as alterações feitas no modelo?"}
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        onConfirm={async () => await updateTemplate()}
        title={"Editar Modelo"}
        emoji={"emoji01"}
        iconColor={ThemeColors.purple400}
      />
    </>
  );
}

export default EditTemplate;
